<template>
  <div class="section-wrapper font-responsive">
    
    <div class="container-fluid section__heading">
      <div class="row">
        <div class="offset-1 col-lg-8 col-xl-6">
          <h3 v-html="component_data.params.title"></h3>
          <p v-html="component_data.params.text"></p>
        </div>
      </div>
    </div>

    <div class="section__content" :key="'content_' + layoutChange">
      <div class="content-depth-0 col-11" :style="'background-image: url('+component_data.params.background+');'" ref="hotpoints">
          <svg class="hotpoints" viewBox="0 0 100 100" preserveAspectRatio="none" v-if="rendered">
            <g v-for="(point, index) in hotpoints" :key="'line_' + index">
              <!-- <path :d="`M${iconX(point.ref)},${iconY(point.ref)} L${point.hotpoint.x},${iconY(point.ref)} ${point.hotpoint.x},${point.hotpoint.y}`" stroke="#E41429" stroke-linecap="round"/> -->

              <line class="line-hor" :x1="iconX(point.ref)" :y1="iconY(point.ref)" :x2="point.hotpoint.x" :y2="iconY(point.ref)" stroke="#E41429" stroke-linecap="round" vector-effect="non-scaling-stroke" />
              <line class="line-vert" :x1="point.hotpoint.x" :y1="iconY(point.ref)" :x2="point.hotpoint.x" :y2="point.hotpoint.y" stroke="#E41429" stroke-linecap="round" vector-effect="non-scaling-stroke" />
            </g>
          </svg>
          <svg class="hotpoints" v-if="rendered">
            <g v-for="(point, index) in hotpoints" :key="'point_' + index">
              <circle :cx="point.hotpoint.x+'%'" :cy="point.hotpoint.y+'%'" r="0.4vw" />
            </g>
          </svg>

          <div class="content_col content_col-right">
            <div class="feature_card" v-if='component_data.params.tooltips.left01'>
              <div class="linestart" ref='left01ico'></div>
              <div class="fn-icon text-white" v-html="component_data.params.tooltips.left01.icon"></div>
              <h3 class="fn-desc" v-html="component_data.params.tooltips.left01.title"></h3>
              <p class="fn-desc" v-html="component_data.params.tooltips.left01.text"></p>
            </div>

            <div class="feature_card" v-if='component_data.params.tooltips.left02'>
              <div class="linestart" ref='left02ico'></div>
              <div class="fn-icon text-white" v-html="component_data.params.tooltips.left02.icon"></div>
              <h3 class="fn-desc" v-html="component_data.params.tooltips.left02.title"></h3>
              <p class="fn-desc" v-html="component_data.params.tooltips.left02.text"></p>
            </div>
          </div>

          <div class="content_col">
            <div class="feature_card" v-if='component_data.params.tooltips.right01'>
              <div class="linestart" ref='right01ico'></div>
              <div class="fn-icon text-white" v-html="component_data.params.tooltips.right01.icon"></div>
              <h3 class="fn-desc" v-html="component_data.params.tooltips.right01.title" ></h3>
              <p class="fn-desc" v-html="component_data.params.tooltips.right01.text"></p>
            </div>

            <div class="feature_card" v-if='component_data.params.tooltips.right02'>
              <div class="linestart" ref='right02ico'></div>
              <div class="fn-icon text-white" v-html="component_data.params.tooltips.right02.icon"></div>
              <h3 class="fn-desc" v-html="component_data.params.tooltips.right02.title" ></h3>
              <p class="fn-desc" v-html="component_data.params.tooltips.right02.text"></p>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['component_data'],
  data(){
    return {
      layoutChange: 2312321,
      appWidth: 0,
      rendered: false
    }
  },
  methods: {
    iconY(ref){
      let y = 0

      console.log(this.$refs[ref].offsetLeft)
      y = this.$refs[ref].offsetTop / this.$refs.hotpoints.clientHeight * 100

      return y
    },
    iconX(ref){
      let y = 0

      console.log(this.$refs[ref].offsetLeft)
      y = this.$refs[ref].offsetLeft / this.$refs.hotpoints.clientWidth * 100

      return y
    }
  },
  mounted(){
    this.$nextTick(()=>{
      if(this.$refs && Object.keys(this.$refs).length > 1){
        this.rendered = true
      }
      setTimeout(()=>{
        this.appWidth = window.innerWidth
      },300)
      window.addEventListener('resize', ()=>{
          this.appWidth = window.innerWidth
      });
    })
  },
  watch: {
    appWidth (newVal, oldVal) {
        if(Math.abs(newVal - oldVal) >= 50){
            this.layoutChange = Date.now()
        }
    }
  },
  computed: {
    hotpoints () {
      let points = []

      Object.keys(this.component_data.params.tooltips).forEach(tooltip => {
        if (this.component_data.params.tooltips[tooltip].hotpoint) {
          let point = this.component_data.params.tooltips[tooltip]
          point.ref = tooltip + 'ico'
          points.push(point)
        }
      })

      return points
    }
  }
}
</script>

<style lang="scss" scoped>
  .hotpoints {
    width: 100%;
    height: 100%;
    position: absolute;
    fill: #E41429;
  }
  .hotpoints path,
  .hotpoints line{
    fill: none;
    stroke: #E41429;
  }
  .line-hor {
    stroke-width: .01vw;
  }
  .line-vert {
    stroke-width: .005vw;
  }
  @supports(vector-effect: non-scaling-stroke) {
    .line-hor,
    .line-vert {
      stroke-width: 2px;
    }
  }
  @supports (-ms-ime-align:auto) {
    .hotpoints path{
       stroke-width:0.18px;
    }
  }
  h3.fn-desc {
    color: #E41429;
    font-family: 'Uni Neue', sans-serif;
    font-size: 2.8em;
    font-weight: 600;
    width: 100%;
  }
  p.fn-desc {
    position: relative;
    font-size: 2em;
    line-height: 1.5em;
    margin-top: .7em;
    font-weight: 700;
    display: inline-block;
    z-index: 0;
    text-shadow: 1px 1px 12px #ffffff;
  }
  .fn-icon {
    width: 8em;
    height: 8em;
    background: #e41429;
    border-radius: 1em;
    margin-bottom: 2em;
    
    &.fn-icon-transparent {
      background: none;
    }

    svg .st0 {
      fill: #fff !important;
    }
  }

  .section-wrapper {
    width: 100%;
    font-family: 'Lato', sans-serif;
    padding-bottom: 8em;

    @media only screen and (max-width : 992px) {
      display: none;
    }

    .section__heading {
      padding-top: 4em;
      padding-bottom: 2em;

      h3 {
        color: #E41429;
        font-size: 4.2em;
        font-weight: 700;
        font-family: 'Uni Neue', sans-serif;
        margin-bottom: 1em;
      }

      p {
        font-size: 2em;
      }
    }

    .section__content {
      position: relative;

      .content-depth-0 {
        height: 36.823vw;
        margin-top: 3em;
        margin-left: calc((100vw / 12) * .5);
        position: relative;
        display: flex;
        justify-content: space-between;

        border-top-right-radius: 6em;
        
        background-repeat: no-repeat;
        background-position: 50% 0%;
        background-size: cover;
        padding: 0;

        &:before {
          content: "";
          background: #FAF9F7;
          height: 39.323vw;
          width: calc((100vw / 12) * 11);
          position: absolute;
          right: -6em;
          top: -3em;
          z-index: -2;

          border-top-left-radius: 6em;
        }

        &:after {
          content: "";
          position: absolute;
          bottom: -3em;
          right: -3em;
          width: calc((100vw / 12) * 3);
          height: 30%;
          z-index: -1;

          border-bottom-left-radius: 6em;

          background: #e41429;
          background: linear-gradient(to right, #e41429 0%,#ae0b11 100%);
        }

        .content_col {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          width: 18%;
          z-index: 1;
          margin: 0 11% 0 auto;

          &-right {
            margin: 0 auto 0 11%;
          }

          p {
            width: 100%;
          }
        }

        .content_col-right .feature_card{
          flex-direction: column;
          display: flex;
          align-items: flex-end;
          text-align: right;
        }

        .feature_card:only-child{
          margin-bottom: auto;
          margin-top: 40%;
        }

        .content_col .linestart {
          position: absolute;
          margin-top: 11em;
          margin-left: -1em;
          width: 1px; height: 1px;
        }
        .content_col-right .linestart {
          margin-left: 1em;
          margin-right: -1em;
        }

        .fn-icon {
          width: 8em;
          height: 8em;
          background: #e41429;
          border-radius: 1em;
          margin-bottom: 1em;
        }
      }
    }
  }
</style>
